"use client";
import * as React from "react";

declare global {
  interface Window {
    _oneall: any[];
  }
}

interface HvsFunnelOverlaySocialLoginProps {
  subdomain: string;
  callbackUrl: string;
  randomKey: string;
  type: "inquiry" | "claim";
  subscribe?: boolean | "indeterminate";
}

function loadScript(oneAllScript: string): HTMLScriptElement {
  const script = document.createElement("script");
  script.id = "oneall-script";
  script.type = "text/javascript";
  script.async = true;
  script.src = oneAllScript;
  const s = document.getElementsByTagName("script")[0];
  s.parentNode?.insertBefore(script, s);

  return script;
}

const HvsFunnelOverlaySocialLogin: React.FC<
  HvsFunnelOverlaySocialLoginProps
> = ({ subdomain, callbackUrl, type, subscribe, randomKey }) => {
  //TODO: Improve this logic, the script should be loaded only once
  const oneAllScript = `https://${subdomain}.api.oneall.com/socialize/library.js`;
  const formatedCallback = `${callbackUrl}&subscribe=${
    type === "inquiry" ? (subscribe ? "1" : "0") : "1"
  }&type=${type}&random_key=${randomKey}`;

  React.useEffect(() => {
    const script = loadScript(oneAllScript);
    script.onload = () => {
      if (!window._oneall) {
        window._oneall = [];
      }

      const _oneall = window._oneall;

      _oneall.push([
        "social_login",
        "set_providers",
        ["google", "linkedin", "facebook"],
      ]);
      _oneall.push(["social_login", "set_popup_usage", "never"]);
      _oneall.push([
        "social_login",
        "set_callback_uri",
        type === "inquiry" ? formatedCallback : callbackUrl,
      ]);

      _oneall.push(["social_login", "do_render_ui", "social_login_container"]);
      _oneall.push([
        "social_login",
        "do_render_ui",
        "social_login_container_claim",
      ]);
    };

    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, [formatedCallback, callbackUrl, type, subscribe, oneAllScript]);

  return type === "inquiry" ? (
    <div id="social_login_container"></div>
  ) : (
    <div id="social_login_container_claim"></div>
  );
};

export default HvsFunnelOverlaySocialLogin;
